import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../_shared/shared.module';

import { SsoRoutingModule } from './sso.routing';
import { SsoComponent } from './sso.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    SharedModule,
    SsoRoutingModule,
  ],
  declarations: [
    SsoComponent
  ],
  providers: []
})
export class SsoModule {
}
